import React from 'react';

function BulbOnIcon(props) {
  return (
    <svg
      className="c-BulbOnIcon"
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.496 16.833v-3.175a5.001 5.001 0 01-2.5-4.333c0-2.958 2.591-5.325 5.625-4.958 2.183.266 3.983 2.008 4.316 4.183a5.001 5.001 0 01-2.441 5.108v3.175a.836.836 0 01-.834.834H8.33a.836.836 0 01-.833-.834zm9.992-6.666h.85a.822.822 0 00.825-.825v-.009a.822.822 0 00-.826-.825h-.841a.822.822 0 00-.825.825v.009a.81.81 0 00.817.825zm-2.209-7.284a.83.83 0 011.175 0 .838.838 0 01.008 1.175l-.325.325a.83.83 0 01-1.175 0l-.008-.008a.827.827 0 010-1.167l.325-.325zM9.996.208h.008c.459 0 .825.367.825.825v.8a.822.822 0 01-.825.825h-.008a.822.822 0 01-.825-.825v-.8c0-.458.366-.825.825-.825zM3.329 9.342v-.009a.822.822 0 00-.825-.825h-.842a.822.822 0 00-.825.825v.009c0 .458.367.825.825.825h.842a.822.822 0 00.825-.825zm1.392-6.467l.325.325a.823.823 0 01-.009 1.175.827.827 0 01-1.166 0l-.325-.325A.83.83 0 114.72 2.875z"
        fill="#FBC91B"
      />
    </svg>
  );
}

export default BulbOnIcon;
